import { useSnapshot } from 'valtio';
import { useStoreActions } from '../store/actions';
import { AppStore } from '../store/store';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import cls from '../styles/Block.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

const BlockB = () => {
  const {
    onHoverOverFloor,
    incrementSelectedFloor,
    decrementSelectedFloor,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor } = useSnapshot(AppStore);

  const onNextPage = (floor: number) => {
    AppStore.currentPage = 32;
    AppStore.selectedFloor = floor;
  };

  return (
    <div className={cls.mainContainer}>
      <div onClick={() => goPrevPage(10)} className={cls.mobileNavigationButton}>
        <img src="./images/arrow.png" alt="Назад" />
        <p>К выбору блока</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={incrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/BlockB/1.png"
                alt="Комната 1"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>1-комнатные</p>
              <p><span>Количество на этаже:</span> <span>1</span></p>
            </div>
          </div>

          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/BlockB/2.png"
                alt="Комната 1"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>Cтудийная двушка</p>
              <p><span>Количество на этаже:</span> <span>1</span></p>
            </div>
          </div>

          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/BlockB/3.png"
                alt="Комната 1"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>2-комнатные</p>
              <p><span>Количество на этаже:</span> <span>2</span></p>
            </div>
          </div>

          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/BlockB/4.png"
                alt="Комната 1"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>3-комнатные</p>
              <p><span>Количество на этаже:</span> <span>3</span></p>
            </div>
          </div>
        </div>

        <button onClick={() => onNextPage(selectedFloor)} className={cls.selectButton}>
          Выбрать
        </button>
      </div>

      <div className={cls.imageContainer}>
        <div onClick={() => goPrevPage(10)} className={cls.navigationButton}>
          <img src="./images/arrow.png" alt="Назад" />
          <p>К выбору блока</p>
        </div>

        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <path onClick={() => onNextPage(3)} onMouseOver={() => onHoverOverFloor(3)} fill="#3292ffcc" className={cls.floor3} d="m 219.41727,692.86817 643.96354,1.50996 0.0451,-33.37685 -644.21232,-2.08574" />
            <circle className={`${cls.symbol3} ${cls.hidden}`} cx="890" cy="680" r="35" fill="#333333" />
            <text className={`${cls.symbol3} ${cls.hidden}`} x="890" y="675" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol3} ${cls.hidden}`} x="890" y="700" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">3</text>

            <path onClick={() => onNextPage(4)} onMouseOver={() => onHoverOverFloor(4)} fill="#3292ffcc" className={cls.floor4} d="m 219.32712,650.39235 643.96354,1.50996 0.0451,-33.37685 -644.21232,-2.08574" />
            <circle className={`${cls.symbol4} ${cls.hidden}`} cx="890" cy="638" r="35" fill="#333333" />
            <text className={`${cls.symbol4} ${cls.hidden}`} x="890" y="633" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol4} ${cls.hidden}`} x="890" y="658" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">4</text>

            <path onClick={() => onNextPage(5)} onMouseOver={() => onHoverOverFloor(5)} fill="#3292ffcc" className={cls.floor5} d="m 219.41727,608.31049 643.9871,3.81739 -0.19123,-38.37353 -88.22087,-0.4462 -1.08364,-2.80471h -95.1689 l 0.44621,1.84856 -87.51969,-1.65733 -0.82867,5.41819 -48.57247,0.57369 -1.9123,-7.01178 -321.68107,1.243" />
            <circle className={`${cls.symbol5} ${cls.hidden}`} cx="890" cy="590" r="35" fill="#333333" />
            <text className={`${cls.symbol5} ${cls.hidden}`} x="890" y="585" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol5} ${cls.hidden}`} x="890" y="610" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">5</text>

            <path onClick={() => onNextPage(6)} onMouseOver={() => onHoverOverFloor(6)} fill="#3292ffcc" className={cls.floor6} d="m 219.00686,561.28616 320.75984,2.03075 3.83247,6.77134 44.68208,-0.12617 1.35263,-4.87873 272.62295,-0.67455 0.51011,-36.04425 -643.69633,-0.77323" />
            <circle className={`${cls.symbol6} ${cls.hidden}`} cx="890" cy="550" r="35" fill="#333333" />
            <text className={`${cls.symbol6} ${cls.hidden}`} x="890" y="545" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol6} ${cls.hidden}`} x="890" y="570" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">6</text>

            <path onClick={() => onNextPage(7)} onMouseOver={() => onHoverOverFloor(7)} fill="#3292ffcc" className={cls.floor7} d="m 219.50741,518.1637 642.88178,2.34382 0.25025,-34.52783 -90.35196,-0.71956 -0.27044,-2.83963 -88.83965,-0.54088 -1.48742,3.24529 -462.41267,-1.56747" />
            <circle className={`${cls.symbol7} ${cls.hidden}`} cx="890" cy="505" r="35" fill="#333333" />
            <text className={`${cls.symbol7} ${cls.hidden}`} x="890" y="500" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol7} ${cls.hidden}`} x="890" y="525" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">7</text>

            <path onClick={() => onNextPage(8)} onMouseOver={() => onHoverOverFloor(8)} fill="#3292ffcc" className={cls.floor8} d="m 219.46853,475.33454 461.36504,1.90252 1.30713,-3.33543 89.20024,0.31552 0.0451,1.57757 -1.03668,2.25367 91.45391,0.6761 -0.36059,-35.7432 -642.02538,-2.70441" />
            <circle className={`${cls.symbol8} ${cls.hidden}`} cx="890" cy="463" r="35" fill="#333333" />
            <text className={`${cls.symbol8} ${cls.hidden}`} x="890" y="458" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol8} ${cls.hidden}`} x="890" y="483" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">8</text>

            <path onClick={() => onNextPage(9)} onMouseOver={() => onHoverOverFloor(9)} fill="#3292ffcc" className={cls.floor9} d="m 219.40479,430.20421 643.57036,4.75401 0.18029,-36.239 -88.97488,-1.17191 0.63103,-3.15514 -96.09647,-0.81132 -0.99161,3.15514 -85.63945,0.0901 -1.71278,8.4738 -47.95809,-0.18029 -1.5325,-9.73585 -321.53965,-1.83203" />
            <circle className={`${cls.symbol9} ${cls.hidden}`} cx="890" cy="418" r="35" fill="#333333" />
            <text className={`${cls.symbol9} ${cls.hidden}`} x="890" y="408" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol9} ${cls.hidden}`} x="890" y="438" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">9</text>

            <path onClick={() => onNextPage(10)} onMouseOver={() => onHoverOverFloor(10)} fill="#3292ffcc" className={cls.floor10} d="m 219.23697,383.39426 321.77894,3.65095 2.43397,9.826 47.00524,-0.451 1.4661,-7.90418 84.0138,0.4462 3.63338,-3.44214 96.31628,1.01989 0.38246,3.3784 86.30856,-1.21112 0.31872,-34.03898 -643.42589,-2.99594" />
            <circle className={`${cls.symbol10} ${cls.hidden}`} cx="890" cy="370" r="35" fill="#333333" />
            <text className={`${cls.symbol10} ${cls.hidden}`} x="890" y="365" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol10} ${cls.hidden}`} x="890" y="390" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">10</text>

            <path onClick={() => onNextPage(11)} onMouseOver={() => onHoverOverFloor(11)} fill="#3292ffcc" className={cls.floor11} d="m 862.83068,347.2103 0.25497,-35.88753 -92.74665,-0.63743 -0.76492,-5.35445 -86.81851,-0.82866 -0.76492,5.54567 -462.52212,-3.50588 -0.12749,34.42143" />
            <circle className={`${cls.symbol11} ${cls.hidden}`} cx="890" cy="330" r="35" fill="#333333" />
            <text className={`${cls.symbol11} ${cls.hidden}`} x="890" y="325" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol11} ${cls.hidden}`} x="890" y="350" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">11</text>

            <path onClick={() => onNextPage(12)} onMouseOver={() => onHoverOverFloor(12)} fill="#3292ffcc" className={cls.floor12} d="m 255.35606,299.02029 424.9817,3.46724 2.65933,-7.21175 87.31004,1.44975 0.76492,6.66119 92.07734,-0.15936 0.0637,-36.84369 -643.74461,-4.78075 -0.25497,37.1624" />
            <circle className={`${cls.symbol12} ${cls.hidden}`} cx="890" cy="285" r="35" fill="#333333" />
            <text className={`${cls.symbol12} ${cls.hidden}`} x="890" y="280" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol12} ${cls.hidden}`} x="890" y="305" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">12</text>

            <path onClick={() => onNextPage(13)} onMouseOver={() => onHoverOverFloor(13)} fill="#3292ffcc" className={cls.floor13} d="m 219.59602,257.49147 643.7446,3.6015 0.0638,-37.67235 -271.73812,-2.9322 -1.21113,12.30248 -48.31237,-0.70801 -1.98323,-13.02621 -321.00971,-2.0104" />
            <circle className={`${cls.symbol13} ${cls.hidden}`} cx="890" cy="240" r="35" fill="#333333" />
            <text className={`${cls.symbol13} ${cls.hidden}`} x="890" y="235" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol13} ${cls.hidden}`} x="890" y="260" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">13</text>

            <path onClick={() => onNextPage(14)} onMouseOver={() => onHoverOverFloor(14)} fill="#3292ffcc" className={cls.floor14} d="m 218.70361,206.78359 323.1153,2.61348 1.52984,14.59724 45.25781,0.63743 2.23102,-13.06739 273.84165,0.89241 -0.31871,-36.39749 -645.84814,-3.69711" />
            <circle className={`${cls.symbol14} ${cls.hidden}`} cx="890" cy="195" r="35" fill="#333333" />
            <text className={`${cls.symbol14} ${cls.hidden}`} x="890" y="190" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol14} ${cls.hidden}`} x="890" y="215" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">14</text>

            <path onClick={() => onNextPage(15)} onMouseOver={() => onHoverOverFloor(15)} fill="#3292ffcc" className={cls.floor15} d="m 219.62789,163.05562 644.7896,6.69077 -1.89308,-50.84278 -642.02538,-2.25367" />
            <circle className={`${cls.symbol15} ${cls.hidden}`} cx="890" cy="140" r="35" fill="#333333" />
            <text className={`${cls.symbol15} ${cls.hidden}`} x="890" y="135" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol15} ${cls.hidden}`} x="890" y="160" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">15</text>
          </svg>

          <LazyLoadImage
            src="./images/blockB.png"
            alt="Структура"
            effect="blur"
          />
        </div>
      </div>
    </div>
  );
};

export default BlockB;
